module.exports = __webpack_public_path__ + "static/media/totalSalesIcon.3b8759b2.svg";